<template>
  <div>
    <b-container v-if="!$store.getters.getIsLoading">
      <b-row>
        <b-col class="surveys-text-container">
          <div class="surveys-text">
            <span>{{ $t("label_reports_surveyOverview_total") }}</span
            ><span class="green-indica">{{ totalAnsweredSurveys }}</span
            ><span>{{ $t("label_reports_surveyOverview_of") }}</span
            ><span>{{ totalSurveys }}</span>
          </div>
          <div class="surveys-text">
            <span>{{ $t("label_reports_surveyOverview_women") }}</span
            ><span class="green-indica">{{ totalAnsweredSurveysWomen }}</span
            ><span>{{ $t("label_reports_surveyOverview_of") }}</span
            ><span>{{ totalSurveysWomen }}</span>
          </div>
          <div class="surveys-text">
            <span>{{ $t("label_reports_surveyOverview_men") }}</span
            ><span class="green-indica">{{ totalAnsweredSurveysMen }}</span
            ><span>{{ $t("label_reports_surveyOverview_of") }}</span
            ><span>{{ totalSurveysMen }}</span>
          </div>
        </b-col>
      </b-row>
      <div class="selectors">
        <b-row>
          <b-col sm class="pbotom">
            <multiselect
              v-model="currentSection"
              :options="getOpinionSurveyFilteredSections()"
              :custom-label="showLabelCurrSection"
              :show-labels="false"
              :allow-empty="false"
              :placeholder="$t('label_selfAssessment_optionList_default')"
            >
              <template #cell(option)="props">
                <div>
                  <span class="option__desc">{{ $t(props.option) }}</span>
                </div>
              </template>
            </multiselect>
          </b-col>
          <b-col sm class="pbotom">
            <multiselect
              v-model="currentQuestionName"
              :options="getQuestionsBySection(currentSection)"
              :custom-label="showLabelCurrQuestionName"
              :option-height="40"
              :show-labels="false"
              :allow-empty="false"
              :placeholder="$t('label_selfAssessment_optionList_default')"
            >
              <template #cell(option)="props">
                <div>
                  <span class="option__desc">{{ $t(props.option) }}</span>
                </div>
              </template>
            </multiselect>
          </b-col>
          <b-col sm class="pbotom">
            <multiselect
              v-model="currentFilterCriteria"
              :options="getFilterCriteriaByQuestion(currentQuestionName)"
              :custom-label="showLabelcurrentFilterCriteria"
              :show-labels="false"
              :allow-empty="false"
              :placeholder="$t('label_selfAssessment_optionList_default')"
            >
              <template #cell(option)="props">
                <div>
                  <span class="option__desc">{{ $t(props.option) }}</span>
                </div>
              </template>
            </multiselect>
          </b-col>
        </b-row>
      </div>

      <b-row v-if="!emptyData">
        <b-col>
          <h3 class="current-section-title">{{ $t(currentSection) }}</h3>
        </b-col>
      </b-row>
      <b-row v-if="!emptyData">
        <b-col>
          <p>{{ $t(currentQuestion) }}</p>
        </b-col>
      </b-row>
      <b-row v-if="emptyData">
        <b-col>
          <p class="noData">
            {{ $t("label_reports_opinionSurvey_notEnoughData") }}
          </p>
        </b-col>
      </b-row>
      <b-row v-if="!emptyData">
        <b-col>
          <card-chart-survey
            :survey="survey"
            :section="currentSection"
            :question="currentQuestionName"
            :filter-criteria="currentFilterCriteria"
            type="participation"
            :alias="
              currentSection +
              currentQuestionName +
              currentFilterCriteria +
              'participation'
            "
            height="300px"
          />
        </b-col>
      </b-row>
      <b-row v-if="!emptyData">
        <b-col>
          <card-chart-survey
            v-if="currentSection !== 'label_opinionSurvey_harassment_title'"
            :survey="survey"
            :type-of-chart="12"
            :section="currentSection"
            :question="currentQuestionName"
            :filter-criteria="currentFilterCriteria"
            type="responses"
            :alias="
              currentSection +
              currentQuestionName +
              currentFilterCriteria +
              'responses'
            "
            height="300px"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import Multiselect from "vue-multiselect";
import i18n from "../lang/lang";
import { axiosCall } from "@/utils/axiosCall";

export default {
  name: "ReportsSurvey",
  components: { Multiselect },
  props: {
    templateId: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      totalSurveys: 0,
      totalAnsweredSurveys: 0,
      totalSurveysMen: 0,
      totalAnsweredSurveysMen: 0,
      totalSurveysWomen: 0,
      totalAnsweredSurveysWomen: 0,

      emptyData: false,
      pages: {},
      today: "",
      rendered: 0,
      dataReady: false,
      pillarsData: false,
      survey: { sections: [] },
      sectionOrder: [
        "label_opinionSurvey_opinionsAboutGender_title",
        "label_opinionSurvey_recruitment_title",
        "label_opinionSurvey_growth_title",
        "label_opinionSurvey_training_title",
        "label_opinionSurvey_remuneration_title",
        "label_opinionSurvey_workFamilyBalance_title",
        "label_opinionSurvey_communication_title",
        "label_opinionSurvey_workEnvironment_title",
        "label_opinionSurvey_harassment_title",
      ],
      currentSection: null,
      currentQuestionName: null,
      currentFilterCriteria: null,
      currentQuestion: null,
    };
  },

  watch: {
    currentSection: function (newVal) {
      this.updateOpinionSurveyCurrentSection({
        section: newVal,
        filteredQuestions: this.getQuestionsBySection(newVal),
      });
    },
    currentQuestionName: function (newVal) {
      this.updateOpinionSurveyCurrentQuestionName(newVal);
    },
    currentFilterCriteria: function () {
      this.checkIfIsEmpty();
    },
    getLang: async function () {
      await this.getReport();
    },
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    ...mapGetters([
      "pillarsIds",
      "getBusiness",
      "getToken",
      "getCurrentSnapshot",
      "getLang",
    ]),
  },
  mounted() {
    this.checkIfIsEmpty();
  },
  created: async function () {
    await this.getReport();
    await axiosCall({
      url:
        "Surveys/getCompletedByGender/" +
        this.getCurrentSnapshot.snapshotId +
        "/" +
        this.templateId,
    })
      .then((resp) => {
        this.totalSurveys =
          resp.data.selfAssessment
            .selfAssessment_staff_responsibility_total_men +
          resp.data.selfAssessment
            .selfAssessment_staff_responsibility_total_women;
        this.totalAnsweredSurveys = resp.data.total;
        this.totalSurveysMen =
          resp.data.selfAssessment.selfAssessment_staff_responsibility_total_men;
        this.totalAnsweredSurveysMen =
          resp.data.survey.optionList_opinionSurvey_basicInformation_qA_sex_male;
        this.totalSurveysWomen =
          resp.data.selfAssessment.selfAssessment_staff_responsibility_total_women;
        this.totalAnsweredSurveysWomen =
          resp.data.survey.optionList_opinionSurvey_basicInformation_qA_sex_female;
      })
      .catch(() => {
      });
  },
  methods: {
    getOpinionSurveyQuestionIsEmpty() {
      if (typeof this.survey === "undefined") {
        return true;
      }

      let s; // state.opinionSurvey.sections.find(x => x.name === state.currentSection)
      this.survey.sections.map((x) => {
        if (x.name === this.currentSection) {
          s = x;
        }
      });
      let q; // s.questions.find(x => x.name === state.currentQuestionName)
      if (typeof s === "undefined") {
        return true;
      }
      s.questions.map((x) => {
        if (x.name === this.currentQuestionName) {
          q = x;
        }
      });

      if (typeof q === "undefined") {
        return true;
      }
      const fc = q.filterCriteria.find(
        (x) => x.name === this.currentFilterCriteria
      );
      if (typeof fc.responsesChart.data === "undefined") {
        return true;
      }
      return false;
    },
    getFilterCriteriaByQuestion(question) {
      var groups = [];
      this.survey.sections.map((i) => {
        i.questions.map((j) => {
          if (j.name === question) {
            j.filterCriteria.map((k) => {
              if (k.participationChart.data.length > 0) {
                groups.push(k.name);
              }
            });
          }
        });
      });
      return groups;
    },
    getQuestionsBySection(section) {
      var questions = [];
      this.survey.sections.map((i) => {
        if (i.name === section) {
          i.questions.map((j) => {
            let dataLength = 0;
            const questionN = j.name.split("_")[3];
            j.filterCriteria.map((filterCriteria) => {
              dataLength =
                dataLength + filterCriteria.participationChart.data.length;
            });
            if (dataLength > 0 && questionN !== "qSH2") {
              questions.push(j.name);
            }
          });
        }
      });
      return questions;
    },
    updateOpinionSurveyCurrentQuestionName(questionName) {
      const s = this.survey.sections.find(
        (x) => x.name === this.currentSection
      );
      const q = s.questions.find((x) => x.name === questionName);
      this.currentQuestion = q.question;
      this.currentFilterCriteria = q.filterCriteria[0].name;
    },
    updateOpinionSurveyCurrentSection(value) {
      this.currentSection = value.section;
      const s = this.survey.sections.find((x) => x.name === value.section);
      const questions = s.questions.filter((q) => {
        return value.filteredQuestions.includes(q.name);
      });
      if (questions.length > 0) {
        this.currentQuestionName = questions[0].name;
        this.currentQuestion = questions[0].question;
        this.currentFilterCriteria = questions[0].filterCriteria[0].name;
      }
    },
    getOpinionSurveyFilteredSections() {
      const s = this.survey.sections;
      const sections = [];
      s.map((section) => {
        let dataLength = 0;
        section.questions.map((question) => {
          question.filterCriteria.map((filterCriteria) => {
            dataLength =
              dataLength + filterCriteria.participationChart.data.length;
          });
        });

        if (dataLength > 0) {
          sections.push(section.name);
        }
      });
      sections.sort((a, b) => {
        const indexA = this.sectionOrder.findIndex((section) => section === a);
        const indexB = this.sectionOrder.findIndex((section) => section === b);
        return indexA - indexB;
      });
      return sections;
    },
    checkIfIsEmpty() {
      this.emptyData = this.getOpinionSurveyQuestionIsEmpty();
    },
    showLabel(item) {
      const label = i18n.tc(item);
      return label.length > 30 ? label.substr(0, 30) + "..." : label;
    },
    showLabelCurrSection(item) {
      if (this.getOpinionSurveyFilteredSections().length === 0) {
        return i18n.tc("label_reports_opinionSurvey_notEnoughData_selector");
      }
      const label = i18n.tc(item);
      return label;
    },
    showLabelCurrQuestionName(item) {
      if (this.getQuestionsBySection(this.currentSection).length === 0) {
        return i18n.tc("label_reports_opinionSurvey_notEnoughData_selector");
      }
      const label = i18n.tc(item);
      return label;
    },
    showLabelcurrentFilterCriteria(item) {
      if (
        this.getFilterCriteriaByQuestion(this.currentQuestionName).length === 0
      ) {
        return i18n.tc("label_reports_opinionSurvey_notEnoughData_selector");
      }
      const label = i18n.tc(item);
      return label.length > 30 ? label.substr(0, 30) + "..." : label;
    },
    getReport: async function () {
      await this.$store.dispatch("SNAPSHOTS_GET");
      await this.$store.dispatch("BUSINESS_GET");
      axiosCall({
        url:
          "Surveys/SurveyReport/" +
          this.getBusiness.id +
          "/" +
          this.getCurrentSnapshot.snapshotId +
          "/" +
          this.templateId,
      }).then((resp) => {
        this.survey = resp.data.surveyData;
        this.currentSection = this.survey.sections[0].name;
        this.currentQuestionName = this.survey.sections[0].questions[0].name;
        this.currentQuestion = this.survey.sections[0].questions[0].question;
        this.currentFilterCriteria =
          this.survey.sections[0].questions[0].filterCriteria[0].name;
        if (this.getOpinionSurveyFilteredSections().length > 0) {
          this.updateOpinionSurveyCurrentSection({
            section: this.getOpinionSurveyFilteredSections()[0],
            filteredQuestions: this.getQuestionsBySection(
              this.getOpinionSurveyFilteredSections()[0]
            ),
          });
          this.updateOpinionSurveyCurrentQuestionName(this.currentQuestionName);
        }
        this.checkIfIsEmpty();
      });
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.pbotom {
  padding-bottom: 10px;
}
.opt_title {
  text-overflow: ellipsis;
  white-space: normal;
  overflow: hidden;
}
.option__desc {
  white-space: normal;
  text-overflow: ellipsis;
}
.multiselect__option {
  white-space: initial;
}
.multiselect__option--highlight {
  background: rgb(2, 206, 167);
}
.multiselect__option--selected.multiselect__option--highlight {
  background: #1e4380;
  color: #fff;
}
</style>
<style lang="scss" scoped>
// components/ReportsOpinionSurvey.vue
@import "../assets/css/variables.scss";

h3 {
  font-family: $font-subtitle;
  font-size: 1.5rem;
  margin-top: 20px;
  text-transform: uppercase;
}
.selectors {
  margin-top: 1rem;
}
.noData {
  text-transform: uppercase;
  font-weight: 500;
  font-size: 1.4rem;
  font-family: "Montserrat-Regular", sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}
.surveys-text {
  font-weight: bold;
  .green-indica {
    color: $secondary-color;
  }
  span {
    padding: 3px;
  }
  &-container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    div {
      margin: 10px;
    }
  }
}
.current-section-title{
  text-align: left;
  font-weight: bold;
}
</style>
